import type { Dataset, DatasetField, MeasurementPanel } from "./api";
import { vehicleClassLabel } from "./vehicleClasses";

export function panelDimensionFilterOptions(field: DatasetField, dataset?: Dataset) {
  if (field.runtime_catalog) return (dataset?.runtime_values?.[field.name] ?? []).map((item) => item.value);
  if (field.type === "boolean") return ["true", "false"];
  return field.type === "enum" ? field.values ?? [] : [];
}

export function panelDimensionFilterValueLabel(field: DatasetField, value: string, dataset?: Dataset) {
  const runtimeLabel = dataset?.runtime_values?.[field.name]?.find((item) => item.value === value)?.label;
  if (runtimeLabel) return runtimeLabel;
  if (field.type === "boolean") return value === "true" ? "Ja" : "Nein";
  return field.name === "class" ? vehicleClassLabel(value) : value;
}

export function runtimeDimensionValueLabel(dataset: Dataset | undefined, name: string, value: unknown) {
  const raw = String(value);
  return dataset?.runtime_values?.[name]?.find((item) => item.value === raw)?.label ?? raw;
}

export function restrictPanelFilters(filters: Record<string, string> | undefined, groupBy: string[]) {
  const grouped = new Set(groupBy);
  return Object.fromEntries(Object.entries(filters ?? {}).filter(([name]) => grouped.has(name)));
}

export function panelFilterSummary(panel: MeasurementPanel, dataset?: Dataset) {
  const filters = panel.filters ?? {};
  const dimensions = new Map((dataset?.fields ?? []).filter((field) => field.kind === "dimension").map((field) => [field.name, field]));
  return panel.group_by.flatMap((name) => {
    const value = filters[name];
    const field = dimensions.get(name);
    if (value === undefined || !field) return [];
    return `${field.title || field.name} = ${panelDimensionFilterValueLabel(field, value, dataset)}`;
  }).join(" · ");
}
